<template>
  <!--未调整完成-->
  <div class="ele-table">
    <!-- 表格 -->
    <el-table
      v-bind="$attrs"
      v-on="$listeners"
      :data="tableData"
      tooltip-effect="dark"
      style="width: 100%"
      @selection-change="selectionRowList"
    >
      <!-- 选择框 -->
      <el-table-column
        v-if="showSelection"
        type="selection"
        width="55"
        align="center"
      ></el-table-column>
      <!-- 展开行 -->
      <el-table-column
        v-if="showExpand"
        type="expand"
        width="55"
        align="center"
      >
        <template slot-scope="props">
          <el-form label-position="left" inline>
            <el-form-item
              v-for="(item, index) in tableLabel"
              :key="index"
              :label="item.param"
            >
              <span>{{ props.row[item.param] }}</span>
            </el-form-item>
          </el-form>
        </template>
      </el-table-column>
      <!-- table内容 -->
      <el-table-column
        v-for="(item, index) in tableLabel"
        :key="index"
        :width="item.width ? item.width : ''"
        :align="item.align ? item.align : 'center'"
        :label="item.label"
        :prop="item.param"
        show-overflow-tooltip
        :sortable="isSortable"
      >
        <template slot-scope="scope">
          <!-- 判空tableData -->
          <!-- <span
            v-if="/^.{0}$/g.test(scope.row[item.param])"
            v-text="'--'"
          ></span> -->
          <!-- 显示tableData -->
          <!-- <span v-else>{{ scope.row[item.param] }}</span> -->

          <!-- render自定义更多内容 -->
          <render-slot
            v-if="item.render"
            :render="item.render"
            :row="scope.row"
            :index="scope.$index"
            :column="item"
          />
          <!-- slot插槽更多内容 -->
          <template v-for="itemslot of slotList" v-else-if="item.slot">
            <slot
              :name="itemslot.slot"
              :index="scope.$index"
              :prop="item.param"
            ></slot>
          </template>
          <!-- 正常内容 -->
          <!--          scope.row[item.param] == [] ||-->
          <span v-else>{{
            /^.{0}$/g.test(scope.row[item.param]) ||
            scope.row[item.param] == null ||
            scope.row[item.param] == undefined
              ? "--"
              : scope.row[item.param]
          }}</span>
        </template>
      </el-table-column>
      <!-- 操作按钮 -->
      <el-table-column
        v-if="tableOptionButton.label"
        :width="tableOptionButton.width ? tableOptionButton.width : ''"
        :label="tableOptionButton.label"
        align="center"
        class-name="fixed-width"
      >
        <template slot-scope="scope">
          <div
            class="tableOptionButton"
            v-for="(item, index) in tableOptionButton.options"
            :key="index"
            :style="spanBr ? '' : 'padding: 0 5px;'"
          >
            <el-button
              :type="item.type ? item.type : 'text'"
              :icon="item.icon ? item.icon : ''"
              @click="handleButton(item.methods, scope.row, scope.$index)"
              size="small"
            >
              {{ item.label }}
            </el-button>
            <span class="spanBr" v-if="spanBr"></span>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <!--<ElementPagination-->
    <!--  ref="ElementPagination"-->
    <!--  v-bind="$attrs"-->
    <!--  v-if="isPagination"-->
    <!--  :pager="pages"-->
    <!--  :position="position"-->
    <!--  :pageSizes="pageSizes ? pageSizes : [10, 20, 30, 40]"-->
    <!--  @paginationSize="handleSizeChange"-->
    <!--  @paginationCurrent="handleCurrentChange"-->
    <!--/>-->
  </div>
</template>

<script>
  // 函数化自定义内容的组件
  var renderSlot = {
    functional: true,
    props: {
      row: Object,
      render: Function,
      index: Number,
      column: {
        type: Object,
        default: null,
      },
    },
    render: (h, data) => {
      const params = {
        row: data.props.row,
        index: data.props.index,
      };
      if (data.props.column) params.column = data.props.column;
      return data.props.render(h, params);
    },
  };
  /**
   * 业务需求，数据多层嵌套，直接过滤数据，只需在使用组件上写上render
   * 例子1：
   * tableLabel: [
   *  { label: "操作人", param: "people" },
   *  { label: "操作类型", param: "type" },
   *  { label: "操作内容", param: "content" },
   *  { label: "操作时间", param: "date", render: (h, params) => { // 使用render
   *    console.log(h, params);
   *    return h('span', params.row.time[0].name)
   *  } },
   * ],
   * tableData: [
   *  {
   *    people: "",
   *    type: "老师管理",
   *    content: "",
   *    time: [ // 嵌套数据
   *      {
   *        date: "2018年10月10日 08:12:12",
   *        name: "gogo新天地"
   *      },
   *      {
   *        date1: "2019年10月10日 08:12:12",
   *        name: "outout旧天地"
   *      }
   *    ]
   *  }
   * ]
   * 例子2：
   * tableLabel: [
   *   { label: "操作人", param: "people" },
   *   { label: "操作类型", param: "type" },
   *   { label: "操作内容", param: "content" },
   *   {
   *     label: "操作时间",
   *     param: "date",
   *     render: (h, params) => {
   *       if (params.row.time[0].src) { // 可以做判断
   *         return h("el-image", { // 可以使用el组件
   *           props: { src: params.row.time[0].src, fit: "fill" },
   *           style: { width: "100px", height: "100px" },
   *         });
   *       } else {
   *         return h("span", params.row.time[0].name);
   *       }
   *     },
   *   },
   * ],
   * tableData: [
   *   {
   *     people: "",
   *     type: "老师管理",
   *     content: "",
   *     time: [
   *       {
   *         date: "2018年10月10日 08:12:12",
   *         name: "gogo新天地",
   *         src:
   *           "",
   *       },
   *       {
   *         date1: "2019年10月10日 08:12:12",
   *         name: "outout旧天地",
   *       },
   *     ],
   *   },
   * ],
   */
  export default {
    name: "EleTable",
    components: { renderSlot },
    props: {
      tableData: {
        // 表格数据
        type: Array,
        default: () => {
          return [];
        },
      },
      tableLabel: {
        // label信息
        type: Array,
        default: () => {
          return [];
        },
      },
      tableOptionButton: {
        // 操作数据
        type: Object,
        default: () => {
          return {};
        },
      },
      showSelection: {
        // 是否显示复选框
        type: Boolean,
        default: false,
      },
      // 操作按钮分割线
      spanBr: {
        type: Boolean,
        default: false,
      },
      // 每一列表头排序
      isSortable: {
        type: Boolean,
        default: false,
      },
      showExpand: {
        type: Boolean,
        default: false,
      },
      pager: {
        // 分页信息
        type: Object,
        default: function () {
          return {
            currentPage: 1,
            pageSize: 10,
            total: 0,
          };
        },
      },
      // 位置
      position: {
        type: String,
        default: "right",
      },
      // 页数的数组
      pageSizes: {
        type: Array
      },
      isPagination: {
        type: Boolean,
        default: true
      }
    },
    data() {
      return {
        pages: this.pager,
      }
    },
    mounted() {
      let _this = this;
      _this.$bus.$on('refreshPageNum', () => {
        _this.pages.currentPage = 1;
      })
    },
    methods: {
      // 触发自定义按钮操作
      handleButton(method = "", row = {}, index = 0) {
        this.$emit("handleButton", { method, row, index });
      },
      // 获取所有的复选框选项
      // getAllSelections() {
      //   console.log(this.$refs.table.selection);
      //   return this.$refs.table.selection;
      // },
      // 选中
      selectionRowList(val) {
        this.$emit("selectionRowList", val);
      },
      // 分页table置顶
      scrollTop() {
        this.$nextTick(() => {
          this.$el.querySelector(".el-table__body-wrapper").scrollTop = 0;
        });
      },
      // size发生变化时，并发送自定义事件
      handleSizeChange(val) {
        this.$emit("handleSizeChange", val );
        this.scrollTop();
      },
      // currentPage发生变化时，发送自定义事件
      handleCurrentChange(val) {
        this.$emit("handleCurrentChange", val );
        this.scrollTop();
      },
    },
    computed: {
      // 获取slotList列表
      slotList() {
        return (
          this.$attrs &&
          this.$attrs.slotList.filter((col) => {
            return col.slot;
          })
        );
      },
    },
  };
</script>

<style lang="less" scoped>
  // 让操作按钮排列一排
  .el-button + .el-button {
    margin-left: 0;
  }
  .tableOptionButton {
    display: inline-block;
  }
  // 按钮的辅助“|”
  .tableOptionButton:not(:last-of-type) {
    .spanBr::after {
      content: "|";
      display: inline-block;
      color: rgba(151, 151, 151, 1);
      font-size: 1px;
      padding: 0 10px;
    }
  }
  /deep/.gutter {
    background: rgba(230, 233, 240, 1);
  }

  .ele-table {
    height: 100%;

    /deep/.el-table {
      background: transparent;

      th > .cell {
        font-size: 16px;
      }

      .el-table__body-wrapper {
        max-height: 660px;
        .show-scroll();
      }


      th, tr, td,
      tr:hover>td.el-table__cell,
      .el-table__expanded-cell {
        background: transparent !important;
      }

      td.el-table__cell,
      th.el-table__cell.is-leaf {
        border-bottom: none;
      }

      .el-table__header {
        height: 55px;
        background: linear-gradient(0deg, #236197, #152F4B);
        border-radius: 5px 5px 0 0;
        font-size: 20px;
        font-family: Microsoft YaHei;
        margin-bottom: 4px;

        .cell {
          color: #fff;
        }

        th {
          /*background: transparent !important;*/
          background: linear-gradient(0deg, #236197, #152F4B) !important;
        }
      }

      .el-table__body {
        .el-table__row {
          width: 100%;
          height: 50px;
          margin: 4px 0;
          border: 1px solid #5ED6FF;
          border-radius: 8px;
        }
        .el-table__cell {
        }
      }
    }


    /deep/ table {
      border-collapse: collapse;

      .el-image {
        width: 80px;
        /*height: 50px;*/
        border-radius: 5px;
        box-shadow: 1px 1px 10px rgba(205, 205, 205, 0.5);
        border: 3px solid rgba(255, 255, 255, 0.5);
      }
    }
  }
</style>

<docs>
  ```
  <template>
    <div>
      <ElementTable
        ref="ElementTable"
        border
        stripe
        height="800"
        @selectionRowList="selectionRowList"
        :tableData="tableData"
        :tableLabel="tableLabel"
        :tableOptionButton="tableOptionButton"
        @handleButton="tableBtnHandle"
        spanBr
        showSelection
        :slotList="tableLabel"
        showExpand
        :isSortable="true"
      >
        <!-- 插槽三个步骤：表头tableLabel: [{ label: "照片", param: "photo", slot: "photo" }]加上（slot: "photo"）；插槽列表:slotList="tableLabel"加上；具体插槽内容<div slot="photo" slot-scope="scope">（v-if="scope.prop == 'photo'" 这个也要写上，对应的表头）</div>加上 -->
        <!-- 插槽switch -->
        <div slot="status" slot-scope="scope">
          <el-switch
            v-if="scope.prop == 'status'"
            v-model="tableDataSwitch[scope.index].status"
            :active-text="tableDataSwitch[scope.index].status ? '启用' : '停用'"
            active-color="#4F88FF"
            inactive-color="#EBEEF5"
            @change="changeSwitch(scope)"
          ></el-switch>
        </div>
        <!-- 插槽photo -->
        <div slot="photo" slot-scope="scope">
          <el-image
            v-if="scope.prop == 'photo'"
            style="width: 100px; height: 100px"
            :src="tableDataPhoto[scope.index].photo"
            :preview-src-list="tableDataPhoto[scope.index].srcList"
            fit="fit"
          >
            <div slot="placeholder" class="image-slot">
              加载中<span class="dot">...</span>
            </div></el-image
          >
        </div>
        <!-- 插槽selection -->
        <div slot="selection" slot-scope="scope">
          <el-select
            v-model="tableDataSelection[scope.index].value"
            clearable
            filterable
            placeholder="请选择"
            v-if="scope.prop == 'selection'"
            @change="changeSelection"
          >
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
              :disabled="item.disabled"
            >
            </el-option>
          </el-select>
        </div>
        <!-- 插槽datetimepicker -->
        <div slot="datetimepicker" slot-scope="scope">
          <el-date-picker
            v-if="scope.prop == 'datetimepicker'"
            v-model="value1"
            type="datetime"
            placeholder="选择日期时间"
            @change="changeDatetimepicker"
          >
          </el-date-picker>
        </div>
        <!-- 插槽datetimerangepicker -->
        <div slot="datetimerangepicker" slot-scope="scope">
          <el-date-picker
            v-if="scope.prop == 'datetimerangepicker'"
            v-model="value2"
            type="datetimerange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="changeDatetimerangepicker"
          >
          </el-date-picker>
        </div>
      </ElementTable>
    </div>
  </template>

  <script>
    export default {
      data() {
        return {
          // 独立插槽的datetimepicker数据数组对象（实际是从请求回来的数据过滤出来） 这里只是简单给个时间格式
          value1: "2000-10-11 10:00:00",
          // 独立插槽的datetimerangepicker数据数组对象（实际是从请求回来的数据过滤出来）这里只是简单给个时间格式
          value2: [new Date(2000, 10, 10, 10, 10), new Date(2000, 10, 11, 10, 10)],
          // table数据数组对象（实际是请求过来的数据，把需要的留下，不需要的过滤出来）
          tableData: [
            // 不传默认--显示
            {
              type: "1",
              name:
                "2222222222222222222222222222222222222222222222222222222222222222222222222222222222",
              inf: "",
              peerName: "4",
              peerINF: 5,
            },
            {
              type: "2",
              name: "5",
              inf: 6,
              peerName: "7",
              peerINF: "",
            },
            {
              type: "3",
              name: "5",
              inf: 6,
              peerName: "7",
              peerINF: 8,
            },
            {
              type: "4",
              name: "5",
              inf: 6,
              peerName: "7",
              peerINF: 8,
            },
            {
              type: "5",
              name: "5",
              inf: 6,
              peerName: "7",
              peerINF: 8,
            },
            {
              type: "6",
              name: "5",
              inf: 6,
              peerName: "7",
              peerINF: 8,
            },
            {
              type: "7",
              name: "5",
              inf: 6,
              peerName: "7",
              peerINF: 8,
            },
            {
              type: "8",
              name: "5",
              inf: 6,
              peerName: "7",
              peerINF: 8,
            },
            {
              type: "9",
              name: "5",
              inf: 6,
              peerName: "7",
              peerINF: 8,
            },
            {
              type: "10",
              name: "5",
              inf: 6,
              peerName: "7",
              peerINF: 8,
            },
            {
              type: "11",
              name: "5",
              inf: 6,
              peerName: "7",
              peerINF: 8,
            },
          ],
          // 独立插槽的switch数据数组对象（实际是从请求回来的数据过滤出来）
          tableDataSwitch: [
            // 不传就是false
            {
              type: "1",
              status: true,
            },
            {
              type: "2",
              status: true,
            },
            {
              type: "3",
              status: true,
            },
            {
              type: "4",
              status: false,
            },
            {
              type: "5",
              status: false,
            },
            {
              type: "6",
              status: false,
            },
            {
              type: "7",
              status: true,
            },
            {
              type: "8",
              status: true,
            },
            {
              type: "9",
              status: false,
            },
            {
              type: "10",
              status: true,
            },
            {
              type: "11",
              status: false,
            },
          ],
          // 独立插槽的photo数据数组对象（实际是从请求回来的数据过滤出来）
          tableDataPhoto: [
            // 不传即加载图片失败
            {
              type: "1",
              photo:
                "https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg",
              srcList: [
                "https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg",
              ],
            },
            {
              type: "2",
              photo:
                "https://cube.elemecdn.com/6/94/4d3ea53c084bad6931a56d5158a48jpeg.jpeg",
              srcList: [
                "https://cube.elemecdn.com/6/94/4d3ea53c084bad6931a56d5158a48jpeg.jpeg",
              ],
            },
            {
              type: "3",
              photo:
                "https://fuss10.elemecdn.com/a/3f/3302e58f9a181d2509f3dc0fa68b0jpeg.jpeg",
              srcList: [
                "https://fuss10.elemecdn.com/a/3f/3302e58f9a181d2509f3dc0fa68b0jpeg.jpeg",
              ],
            },
            {
              type: "4",
              photo:
                "https://fuss10.elemecdn.com/1/34/19aa98b1fcb2781c4fba33d850549jpeg.jpeg",
              srcList: [
                "https://fuss10.elemecdn.com/1/34/19aa98b1fcb2781c4fba33d850549jpeg.jpeg",
              ],
            },
            {
              type: "5",
              photo:
                "https://fuss10.elemecdn.com/8/27/f01c15bb73e1ef3793e64e6b7bbccjpeg.jpeg",
              srcList: [
                "https://fuss10.elemecdn.com/8/27/f01c15bb73e1ef3793e64e6b7bbccjpeg.jpeg",
              ],
            },
            {
              type: "6",
              photo:
                "https://fuss10.elemecdn.com/1/8e/aeffeb4de74e2fde4bd74fc7b4486jpeg.jpeg",
              srcList: [
                "https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg",
              ],
            },
            {
              type: "7",
              photo:
                "https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg",
              srcList: [
                "https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg",
              ],
            },
            {
              type: "8",
              photo:
                "https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg",
              srcList: [
                "https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg",
              ],
            },
            {
              type: "9",
              photo:
                "https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg",
              srcList: [
                "https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg",
              ],
            },
            {
              type: "10",
              photo:
                "https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg",
              srcList: [
                "https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg",
              ],
            },
            {
              type: "11",
              photo:
                "https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg",
              srcList: [
                "https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg",
              ],
            },
          ],
          // 独立插槽的selection数据数组对象（实际是从请求回来的数据过滤出来）
          tableDataSelection: [
            // 不传即空值
            {
              type: "1",
              value: "选项4",
              label: "龙须面",
            },
            {
              type: "2",
              value: "选项1",
              label: "黄金糕",
            },
            {
              type: "3",
              value: "选项3",
              label: "蚵仔煎",
            },
            {
              type: "4",
              value: "选项1",
              label: "黄金糕",
            },
            {
              type: "5",
              value: "选项5",
              label: "北京烤鸭",
            },
            {
              type: "6",
              value: "选项3",
              label: "蚵仔煎",
            },
            {
              type: "7",
              value: "选项2",
              label: "双皮奶",
            },
            {
              type: "8",
              value: "选项1",
              label: "黄金糕",
            },
            {
              type: "9",
              value: "选项1",
              label: "黄金糕",
            },
            {
              type: "10",
              value: "选项3",
              label: "蚵仔煎",
            },
            {
              type: "11",
              value: "选项2",
              label: "双皮奶",
            },
          ],
          // 下拉框的数据数组对象
          options: [
            {
              value: "选项1",
              label: "黄金糕",
            },
            {
              value: "选项2",
              label: "双皮奶",
            },
            {
              value: "选项3",
              label: "蚵仔煎",
              disabled: true,
            },
            {
              value: "选项4",
              label: "龙须面",
            },
            {
              value: "选项5",
              label: "北京烤鸭",
            },
          ],
          // 表格头部内容数组对象（1.新增列共两种方式：这种是用数据通过插槽的方式使用）
          tableLabel: [
            { label: "照片", param: "photo", slot: "photo" },
            { label: "参数1", param: "type", width: 100 },
            { label: "参数2", param: "name", width: 100 },
            { label: "参数3", param: "inf", width: 100 },
            { label: "参数4", param: "peerName", width: 100 },
            { label: "参数5", param: "peerINF", width: 100 },
            { label: "是否开启", param: "status", slot: "status" },
            { label: "下拉选择", param: "selection", slot: "selection" },
            {
              label: "单日期",
              param: "datetimepicker",
              width: 300,
              slot: "datetimepicker",
            },
            {
              label: "双日期",
              param: "datetimerangepicker",
              slot: "datetimerangepicker",
            },
          ],
          // 新增操作一列数组对象（2.新增列共两种方式：这种是组件写好再使用）
          tableOptionButton: {
            label: "操作",
            options: [
              { label: "编辑", methods: "editDetail" },
              { label: "删除", methods: "detailDetail" },
              {
                label: "设置",
                methods: "setDetail",
                type: "primary",
                icon: "el-icon-edit",
              },
            ],
          },
        };
      },
      methods: {
        selectionRowList(rows) {
          console.log(rows);
          this.selectedList = rows.map((item) => Number(item.type));
          console.log(this.selectedList);
        },
        tableBtnHandle({ method, row, index }) {
          // 拿到对应一行的tableData数据
          console.log(method, row, index);
          // 拿到对应一行的tableDataPhoto数据
          let { photo } = this.tableDataPhoto.find((item) => item.type == row.type);
          console.log(photo);
          // 拿到对应一行的tableDataSwitch数据
          let { status } = this.tableDataSwitch.find(
            (item) => item.type == row.type
          );
          console.log(status);
          // 拿到对应一行的tableDataSelection数据
          let { value, label } = this.tableDataSelection.find(
            (item) => item.type == row.type
          );
          console.log(value, label);
          // 同样道理，仿造以上，拿到时间的datetimepicker数据和datetimerangepicker数据（时间按需转换格式，可通过封装方法使用转换）
          console.log(this.value1);
          console.log(this.value2);
          // 把上面的所有的参数按需组合起来放到下面方法使用
          // 对应的按钮方法（根据自己写的操作栏的方法名自定义）
          if (method == "editDetail") {
            console.log("一般是打开Dialog传值");
          } else if (method == "detailDetail") {
            console.log("根据row的id来删除有对应的方法");
          } else {
            console.log("更多功能");
          }
        },
        changeSwitch({ index }) {
          console.log(index);
          let row = this.$refs.ElementTable.tableData[index];
          let row1 = this.tableData[index];
          console.log(row);
          console.log(row1);
        },
        changeSelection(v) {
          console.log(v);
        },
        changeDatetimepicker(v) {
          console.log(v);
        },
        changeDatetimerangepicker(v) {
          console.log(v);
        },
      },
    };
  </script>
  ```
</docs>